/**
 * Parse the patientId out of the path: "/patient/:patientId/summary"
 * @returns {number} patientId
 */
export default function getPatientIdFromUrl(url) {
  return parseInt(url.split('/')[2], 10);
}
